import { bedaConfig } from './jsx-adapter';

export async function submitWordPressEnquiry(options: RequestInit): Promise<Response> {
  const config = bedaConfig();
  if (!config.enquiriesAvailable || !config.enquiryEndpoint || !config.nonce) {
    return new Response(JSON.stringify({ error: 'The enquiry service is not available. Please contact BEDA directly by phone, email or WhatsApp.' }), { status: 503, headers: { 'Content-Type': 'application/json' } });
  }
  const fields = JSON.parse(String(options.body || '{}'));
  const form = new FormData();
  form.set('action', 'beda_submit_enquiry');
  form.set('beda_nonce', config.nonce);
  form.set('request_id', fields.requestId || '');
  for (const name of ['name', 'organization', 'email', 'phone', 'location', 'topic', 'message', 'website']) {
    form.set(name, String(fields[name] || ''));
  }
  if (fields.consent === true) form.set('consent', 'on');
  const response = await fetch(config.enquiryEndpoint, {
    method: 'POST', body: form, credentials: 'same-origin',
    headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
  });
  const text = await response.text();
  let body;
  try { body = JSON.parse(text); }
  catch { return new Response(JSON.stringify({ error: 'Your enquiry could not be saved. Your details are still here. Please try again or contact BEDA directly.' }), { status: 502, headers: { 'Content-Type': 'application/json' } }); }
  // Support both the existing plugin's plain JSON response and WordPress's JSON envelope.
  if (body && typeof body.data === 'object' && body.data) body = { ...body, ...body.data };
  let status = response.status;
  if (body?.success === false && response.ok) status = 400;
  if (typeof body?.message === 'string' && !body.error && !body.reference) body.error = body.message;
  return new Response(JSON.stringify(body), { status, headers: { 'Content-Type': 'application/json' } });
}
